import axios from 'axios'
import createDopHeader from './dpop-creator'
import { getUser } from '@/auth/authService'

const axiosInstance = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL,
	headers: { 'Content-Type': 'application/json' },
	// withCredentials: true,
	timeout: 600000,
})

axiosInstance.interceptors.request.use(
	async (config) => {
		const { baseURL, url, method } = config
        const user = await getUser()
		if (user?.id_token) {
			const token = user.id_token
			config.headers.authorization = `Bearer ${token}`
		}
        if (user?.access_token) {
            config.headers['x-authorization'] = `Bearer ${user.access_token}`
        }
		const dpop = await createDopHeader(
			/^http(s)?:\/\//.test(url!) ? url! : `${baseURL}${url}`,
			method!.toUpperCase()
		)
		config.headers.dpop = dpop
		return config
	},
	(error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
	(response) => {
		return response
	},
	async (error) => {
		if (error.response) {
			const { data, status } = error.response
			if (data || status) {
				if (data.message === 'FORBIDDEN' || status === 403) {
					return Promise.reject('FORBIDDEN')
				}
				return Promise.reject(data)
			}
		}
		return Promise.reject(error)
	}
)

export default axiosInstance
